export default "__VITE_ASSET__CUz3tybf__"